import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import styles from './SettingsChoicesManager.module.scss'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import UniversalChoiceModal from '../../../ContentBox/Global/GlobalModalSingle/templates/CRM/UniversalChoiceModal/UniversalChoiceModal'
import { ChoiceItem } from '../ChoiceItem/ChoiceItem'

export const SettingsChoicesManager = ({
  apiEndpoint,
  pageTitle,
  addButtonText,
  emptyStateText,
  translate,
}) => {
  const [items, setItems] = useState([])

  const fetchItems = async () => {
    try {
      const { data } = await superAxiosRequest({
        link: apiEndpoint,
        method: 'get',
        crm: true,
      })
      if (data?.value?.choices) {
        setItems(data.value.choices)
      }
    } catch (error) {
      console.error(`Ошибка загрузки данных из ${apiEndpoint}:`, error)
    }
  }

  useEffect(() => {
    fetchItems()
  }, [apiEndpoint])

  const updateItems = async (updatedChoices) => {
    try {
      const payload = {
        value: {
          choices: updatedChoices,
        },
      }

      await superAxiosRequest(
        {
          link: apiEndpoint,
          method: 'put',
          crm: true,
        },
        payload,
      )
      await fetchItems()
    } catch (error) {
      console.error('Полная ошибка обновления:', error)
      throw error
    }
  }

  const addItem = () => {
    const maxId = items.length > 0 ? Math.max(...items.map((i) => i.id)) : 0

    const ms = {
      // Передаем динамические label и placeholder
      modalBodyComponent: () => (
        <UniversalChoiceModal
          label={pageTitle}
          placeholder={`Введите название для "${pageTitle.toLowerCase()}"`}
        />
      ),
      button: 'Save',
      link: apiEndpoint,
      title: `Добавить: ${pageTitle}`,
      isResponsive: true,
      is_put: true,
      crm: true,
      onBeforeSubmit: (data) => {
        const newItem = {
          id: maxId + 1,
          name: data.value, // Читаем из data.value
        }
        return {
          value: {
            choices: [...items, newItem],
          },
        }
      },
      onSubmitSuccess: fetchItems,
      valid: { value: 'required' },
    }
    asideModalStore.activity(ms)
  }

  const editItem = (item) => {
    const ms = {
      modalBodyComponent: () => (
        <UniversalChoiceModal
          label={pageTitle}
          placeholder={`Введите название для "${pageTitle.toLowerCase()}"`}
        />
      ),
      button: 'Сохранить',
      link: apiEndpoint,
      title: `Редактировать: ${pageTitle}`,
      isResponsive: true,
      is_put: true,
      crm: true,
      onBeforeSubmit: (data) => {
        const updated = items.map((i) =>
          i.id === item.id ? { ...i, name: data.value } : i,
        )
        return {
          value: {
            choices: updated,
          },
        }
      },
      onSubmitSuccess: fetchItems,
      valid: { value: 'required' },
    }

    asideModalStore.activity(ms, { value: item.name })
  }

  const deleteItem = (itemId) => {
    swal({
      title: 'Вы уверены?',
      text: 'После удаления элемент нельзя будет восстановить.',
      icon: 'warning',
      buttons: {
        cancel: { text: 'Отмена', value: null, visible: true },
        confirm: {
          text: 'Удалить',
          value: true,
          className: 'swal-button--danger',
        },
      },
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const updated = items.filter((i) => i.id !== itemId)
          await updateItems(updated)
          swal('Успешно!', 'Элемент был удален.', 'success')
        } catch (error) {
          swal('Ошибка!', 'Не удалось удалить элемент.', 'error')
          console.error('Ошибка удаления:', error)
        }
      }
    })
  }

  const action = (actionType, e, item) => {
    const actions = new Map([
      ['edit', () => editItem(item)],
      ['delete', () => deleteItem(item.id)],
    ])
    return actions.get(actionType)?.()
  }

  const menu = [
    { name: translate.edit, action: 'edit' },
    { name: translate.delete, action: 'delete' },
  ]

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <PageHeader title={pageTitle} />
        <div className={styles.settingsLocalization__box}>
          <HeaderAddButton title={addButtonText} onClick={addItem} />
        </div>
      </div>

      <div className={styles.listContainer}>
        {items.length === 0 ? (
          <div className={styles.noItems}>{emptyStateText}</div>
        ) : (
          items.map((item, index) => (
            <ChoiceItem
              key={`${item.id}-${index}`}
              item={item}
              action={action}
              index={index}
              menu={menu}
            />
          ))
        )}
      </div>
    </div>
  )
}
